import { action } from "mobx";
import Immersive3dTourPanoramaZipDownloadRepository from "~/repository/Immersive3dTour/Immersive3dTourPanoramaZipDownloadRepository";

class Immersive3dTourPanoramaZipDownloadStore {
  /**
   * @property {number|null}
   */
  tourId = null;

  /**
   * @property {Immersive3dTourPanoramaZipDownloadRepository|null}
   */
  immersive3dTourPanoramaZipDownloadRepository = null;

  constructor() {
    this.immersive3dTourPanoramaZipDownloadRepository = new Immersive3dTourPanoramaZipDownloadRepository();
  }

  @action
  getUrlForGetOne() {
    return this.immersive3dTourPanoramaZipDownloadRepository.getUrlForFetchOne(this.tourId);
  }
}

export default Immersive3dTourPanoramaZipDownloadStore;
